import { alpha, Theme } from "@mui/material";
import { border, borderRadius, display, height, width } from "@mui/system";
import { gridClasses } from "@mui/x-data-grid";

const useStyles = (theme: Theme) => ({
  dataGrid: {
    // height: "calc(100% - 3rem)",
    height: "100%",
    width: "100%",
    fontSize: "1rem",
    borderRadius: 1,
    backgroundColor: "transparent", //theme.palette.background.paper,
    mt: 1,
    border: "none", // "1px solid " + theme.palette.color.appBarBorder,
    overflowY: "hidden",
    "& .MuiDataGrid-columnHeaders": { display: "none" },
    "& .MuiDataGrid-scrollbar--vertical": {
      display: "none",
    },
    "& .MuiDataGrid-scrollbarFiller": {
      display: "none",
    },
    [`& .${gridClasses.row}`]: {
      backgroundColor: alpha(theme.palette.background.paper, 0.8),
      border: "none",
      "&:hover": {
        backgroundColor: alpha(theme.palette.primary.main, 0.05),
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
    "& .MuiDataGrid-filler": {
      display: "none",
    },
    "& .MuiDataGrid-cell": {
      border: "none",
      borderTop: "none",
    },
    "& .MuiDataGrid-footerContainer": {
      backgroundColor: "transparent", // Altera cor do rodapé
      border: 0,
      height: "45px",
      display: "flex",
      justifyContent: "center",
    },
    // "--DataGrid-overlayHeight": "500px"
  },
  linearProgress: {
    height: "20px",
    width: "100%",
    borderRadius: 0.5,
  },
  textProgress: {
    fontWeight: 500,
    width: "60px",
    textAlign: "center",
    fontSize: "0.875rem",
    color: theme.palette.text.primary,
  },
  boxLinearProgress: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    borderTop: "2px dashed " + theme.palette.background.textField,
  },
  text: {
    wordBreak: "break-all",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "0.9rem",
  },
});

export default useStyles;
